import React from 'react';
import { LoadingOverlay } from '@eb/eds-loading-overlay';

const RAISER_CLASSNAME = 'raise-loading-overlay';

// the manage pages can't show custom CSS.
// https://jira.evbhome.com/browse/EB-105146
// use this workaround to apply the styles we need.
const RAISER_STYLES = `
    .${RAISER_CLASSNAME} {
        z-index: 999;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
`;

// by doing it this way, we ensure that the LoadingOverlay
// component is still present in the React structure
// even when it isn't shown (but this div won't be).
// in this way, we don't interrupt the normal behavior
// from EDS.
const OptionalRaiser = ({ isShown, children }) =>
    !isShown ? (
        children
    ) : (
        <div className={RAISER_CLASSNAME}>
            <style
                type="text/css"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: RAISER_STYLES,
                }}
            />
            {children}
        </div>
    );

// the purpose of this is to raise the z-index above header
export const RaisedLoadingOverlay = (props) => (
    <OptionalRaiser isShown={props.isShown}>
        <LoadingOverlay {...props} />
    </OptionalRaiser>
);
